import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'

export const submitInfluencerApplication = createServerFn({ method: 'POST' })
  .inputValidator((input: unknown) => input)
  .handler(async ({ data }) => {
    const { submitApplication } = await import('./influencers.server')
    return await submitApplication(data)
  })
export const confirmInfluencerEmail = createServerFn({ method: 'POST' })
  .inputValidator((input: unknown) => input)
  .handler(async ({ data }) => {
    const parsed = z.object({ token: z.string().max(128).regex(/^[A-Za-z0-9_-]{43}$/) }).safeParse(data)
    if (!parsed.success) return { status: 'invalid_or_expired' as const }
    const { confirmEmail } = await import('./influencers.server')
    return await confirmEmail(parsed.data.token)
  })
export const resendInfluencerConfirmation = createServerFn({ method: 'POST' })
  .inputValidator((input: unknown) => input)
  .handler(async ({ data }) => {
    const parsed = z.object({ email: z.string().trim().toLowerCase().email().max(255) }).safeParse(data)
    if (!parsed.success) return { status: 'ok' as const }
    const { resendConfirmation } = await import('./influencers.server')
    return await resendConfirmation(parsed.data.email)
  })

export const attachInfluencerVideo = createServerFn({ method: 'POST' })
  .inputValidator((input: unknown) => input)
  .handler(async ({ data }) => {
    const parsed = z.object({
      path: z.string().max(100).regex(/^[0-9a-f-]{36}\/[0-9a-f-]{36}\.(mp4|mov)$/i).refine(path => z.string().uuid().safeParse(path.split('/')[0]).success && z.string().uuid().safeParse(path.split('/')[1]?.split('.')[0]).success),
      duration_seconds: z.number().finite().optional(),
    }).safeParse(data)
    if (!parsed.success) return { status: 'invalid' as const }
    const { supabaseAdmin } = await import('@/integrations/supabase/client.server')
    const { attachVideo } = await import('./influencer-video.server')
    return attachVideo(supabaseAdmin, parsed.data.path, parsed.data.duration_seconds)
  })
